import React from 'react';
import {BANNER_TYPE} from "../../../../constants/commons";
import CustomBanner from "../carousel";
import ViewAllTitle from "../../../../components/ViewAllTitle";

const PromotionalEvents = ({mobile}) => {
  return (
    <div className="mt-4 w-full text-rand-100">

      <ViewAllTitle title="Promotional Events"/>

      <CustomBanner bannerType={BANNER_TYPE.promotional_events} mobile={mobile}/>
    </div>

  );
};

export default React.memo(PromotionalEvents);